import { Component } from '@angular/core';

@Component({
  template: "<div>OK</div>",
})
export class HealthCheckComponent {}

